export const LOAD_INBOUNDDATA_LOADING = 'REDUX_SAGA_LOAD_INBOUNDDATA_LOADING';
export const LOAD_INBOUNDDATA_SUCCESS = 'REDUX_SAGA_LOAD_INBOUNDDATA_SUCCESS';
export const LOAD_INBOUNDDATA_ERROR = 'REDUX_SAGA_LOAD_INBOUNDDATA_ERROR';

export const loadExceptions = () => dispatch => {
    dispatch({ type: LOAD_INBOUNDDATA_LOADING });
};